/**
 * @description 作业平台 platform
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const platformBiz = new Logic()

platformBiz.excutePlatform = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.platform.excutePlatform,
    data: data
  })
}

platformBiz.getHisPlatform = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.platform.getHisPlatform,
    data: data
  })
}

platformBiz.getPlatforms = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.platform.getPlatforms,
    data: data
  })
}

platformBiz.savePlatform = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.platform.savePlatform,
    data: data
  })
}

platformBiz.getPlatformById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.platform.getPlatformById,
    data: data
  })
}

platformBiz.getPlatformLog = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.platform.getPlatformLog,
    data: data
  })
}

platformBiz.deletePlatform = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.platform.deletePlatform,
    data: data
  })
}

export default platformBiz
